export default {
  GET_ALL: `#graphql
  query getArticles($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getArticles(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        article,
        activeBrands,
        activeArticle,
        order,
        spanish,
        letter,
        image,
        folder
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  GET_HISTORY: `#graphql
  query getArticlesHistory($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getArticlesHistory(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        _id,
        version,
        activeBrands,
        activeArticle,
        spanish,
        letter,
        image,
        folder,
        active,
        order,
        transaction,
        createdAt,
        createdBy,
        updatedBy
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  NEW: `#graphql
  mutation NewArticle($article: ArticleInput!) {
    newArticle(input: $article)
    {
      article,
      activeBrands,
      activeArticle,
      order,
      spanish,
      letter,
      image,
      folder
    }            
  }`,

  UPDATE: `#graphql
  mutation UpdateArticle($article: String!, $articleUpdate: ArticleUpdateInput!) {
    updateArticle(article:$article, articleUpdate: $articleUpdate)
    {
      article
    }            
  }`,

  DELETE: `#graphql
  mutation DeleteArticle($article: String!) {
    deleteArticle(article:$article)
    {
      article
    }            
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/article.js